import { BaseContainerModel } from '../base-container.model';
import { bl_ocr_generic_doc_hdr_RowClass, bl_ocr_generic_doc_line_RowClass } from '../../dbschema';

export class OCRGenericDocContainerModel extends BaseContainerModel {
  bl_ocr_generic_doc_hdr: bl_ocr_generic_doc_hdr_RowClass = new bl_ocr_generic_doc_hdr_RowClass();
  bl_ocr_generic_doc_lines: bl_ocr_generic_doc_line_RowClass[] = []
}
